import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * True when the current session is impersonating another user. Impersonation
 * is carried as a custom claim on the Auth0 access token (set server-side via
 * Auth0 user_metadata), so the only way to know client-side is to decode it.
 */
export function useIsImpersonating(): boolean {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setIsImpersonating(false);
      return;
    }
    const checkImpersonation = async () => {
      try {
        const token = await getAccessTokenSilently();
        const payload = JSON.parse(atob(token.split(".")[1]));
        const sgiClaims = payload["http://hub.sgi.com/jwt/claims"] ?? {};
        setIsImpersonating(!!sgiClaims["sgi_hub_impersonate_sso_id"]);
      } catch {
        setIsImpersonating(false);
      }
    };
    checkImpersonation();
  }, [getAccessTokenSilently, isAuthenticated]);

  return isImpersonating;
}
